export default __webpack_public_path__ + "static/media/jungle-rain.3a1268f1.ogg";